import imageCompression from 'browser-image-compression';

import Fire from './fire.service'

import copyToClipboard from './clipboard'

export default class Tools {
  
  static vibrate(force = 1000) {
    if (window.navigator.vibrate)
      window.navigator.vibrate(force);
  }

  static showFilePicker(id: string) {
    const doc: any = document.getElementById(id)
    if (doc)
      doc.click()
  }

  static getFileExtension(name: string) {
    const parts = name.split('.');
    return parts[parts.length - 1].toLowerCase();
  }
  static isFileImage(name: string) {
    const ext = this.getFileExtension(name)
    return (ext === 'jpeg' || ext === 'jpg' ||
      ext === 'png' || ext === 'gif')
  }

  static toMegabytes(size: number) {
    return size / 1024 / 1024
  }

  static async requestSmallImage(event) {
    if (!event.target.files || event.target.files.length === 0)
      throw Error('Aucun fichier uploadé')
    const imageFile = event.target.files[0]
    const maxSize = 0.5
    const name = imageFile.name
    const size = this.toMegabytes(imageFile.size)
    console.log('Old size: ' + size)
    if (!this.isFileImage(name))
      throw Error("Votre fichier doit être un PNG, JPG, JPEG ou GIF")
    
    const options = {
      maxSizeMB: maxSize,
      maxWidthOrHeight: 1200,
      useWebWorker: true
    }
    try {
      const compressedFile = await imageCompression(imageFile, options);
      console.log('New size: ' + this.toMegabytes(compressedFile.size))
      const url = URL.createObjectURL(compressedFile);
      return url
    } catch (err) {
      console.log('Failed to compress file: ')
      console.log(err)
    }
    throw Error("Impossible d'uploader ce fichier")
  }

  static formatPictures(pictures?: string[]) {
    const pics = pictures || []
    const parsed: any = []
    for (const pic of pics) {
      parsed.push({
        url: pic,
        saved: true,
      })
    }
    return parsed
  }
  static formatPicture(picture?: string) {
    if (!picture || picture === '')
      return (null)
    return {
      url: picture,
      saved: true
    }
  }

  static async uploadPicture(path: string, pic?: any) {
    if (!pic)
      return null
    if (!pic.saved)
      return await Fire.uploadFile(path, pic.url)
    return pic.url
  }

  static async uploadPictures(directory: string, pictures?: any[]) {
    const pics = pictures || []
    const formatted: string[] = []
    for (let i = 0; i < pics.length; ++i) {
      const pic = pics[i]
      if (!pic.saved) {
        const date = new Date().toString()
        const uploaded = await Fire.uploadFile(directory + '/picture-' + i + '-' + date + '.png', pic.url)
        formatted.push(uploaded)
      } else {
        formatted.push(pic.url)
      }
    }
    return formatted
  }

  static matchesSearch(search, val) {
    return !search.length || (val || '').toLowerCase().includes(search.toLowerCase())
  }

  static renderPrice(price?: number) {
    return Number(price || 0).toFixed(2) + '€'
  }

  static copyToClipboard(text: string) {
    copyToClipboard(text)
  }

  static applyPopFee(price: number, fee: number) {
    return price - price * fee / 100
  }

  static cancellablePromise(promise: Promise<any | void>): any {
    const isCancelled = { value: false };
    const wrappedPromise = new Promise((res, rej) => {
      promise
        .then(d => {
          return isCancelled.value ? rej(isCancelled) : res(d);
        })
        .catch(e => {
          rej(isCancelled.value ? isCancelled : e);
        });
    });

    return {
      promise: wrappedPromise,
      cancel: () => {
        isCancelled.value = true;
      }
    };
  }

  static rowsToCSV(columns: any[], data: any[]) {
    let content = ''
    for (let i = 0; i < columns.length; ++i) {
      if (i !== 0)
        content += ','
      const col = columns[i]
      content += '"' + col.name + '"'
    }
    content += '\n'
    for (const item of data) {
      let line = ''
      for (let i = 0; i < columns.length; ++i) {
        if (i !== 0)
          line += ','
        const col = columns[i]
        line += '"' + col.format(item) + '"'
      }
      line += '\n'
      content += line
    }
    return content
  }

  static downloadFile(filename, content) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
}